import React, { useEffect, useRef } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { Button } from '@/components/buttons/Button';
import { openZendesk } from '@/components/Zendesk';

const RegistrationCustomerSupport = ({ closeModal }: { closeModal: VoidFunction }) => {
  const intl = useIntl();
  const absoluteNavigate = useAbsoluteNavigate();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const openHelp = () => {
    triggerGTag(GTagEvents.ont_reg_error_help_click);
    openZendesk();
    closeModal();
  };

  const returnToHome = () => {
    triggerGTag(GTagEvents.ont_reg_error_home_click);
    closeModal();
    absoluteNavigate('/');
  };

  useEffect(() => {
    if (containerRef && containerRef.current) {
      window.scrollTo({ top: containerRef.current.offsetTop - 84 });
    }
  }, []);

  return (
    <div ref={containerRef} className="p-8 text-white">
      <div>
        <FormattedMessage
          id="ontario.registration.error.account_blocked"
          values={{
            b: str => <span className="font-bold">{str}</span>,
            p: str => <p className="mt-4">{str}</p>,
          }}
        />
      </div>
      <div className="mt-8">
        <Button
          text={intl.formatMessage({ id: 'help.contactButton' })}
          type="button"
          btnType="primary"
          onClickHandler={openHelp}
        />
        <div className="mt-4">
          <Button
            text={intl.formatMessage({ id: 'registration.ontario.accountBlocked.cta' })}
            type="button"
            btnType="secondary"
            onClickHandler={returnToHome}
          />
        </div>
      </div>
    </div>
  );
};

export default RegistrationCustomerSupport;
